import React, { useEffect } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { PainReality } from './components/PainReality';
import { SevenDayPlan } from './components/SevenDayPlan';
import { FacebookWall } from './components/FacebookWall';
import { ValueStack } from './components/ValueStack';
import { TwoPaths } from './components/TwoPaths';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { RecentPurchaseToast } from './components/RecentPurchaseToast';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel('1666572947695847');
  }, []);
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <Hero data-id="element-2" />
      <PainReality data-id="element-3" />
      <SevenDayPlan data-id="element-4" />
      <FacebookWall data-id="element-5" />
      <ValueStack data-id="element-6" />
      <TwoPaths data-id="element-7" />
      <FAQ data-id="element-8" />
      <Footer data-id="element-9" />
      <RecentPurchaseToast data-id="element-10" />

      {/* Meta Pixel Noscript Fallback */}
      <noscript data-id="element-11">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1666572947695847&ev=PageView&noscript=1" alt="" data-id="element-12" />
      </noscript>
    </div>;
}